import { createI18n } from 'vue-i18n'

export const languages = [
  {
    active    : true,
    visible   : true,
    default   : true,
    name      : 'Ελληνικά',
    short_name: 'GR',
    locale    : 'el',
    code      : 'el-GR',
    code2     : 'el_GR',
    icon      : '/img/flags/1x1/gr.svg'
  },
  {
    active    : true,
    visible   : true,
    default   : false,
    name      : 'English',
    short_name: 'EN',
    locale    : 'en',
    code      : 'en-US',
    code2     : 'en_US',
    icon      : '/img/flags/1x1/gb.svg'
  }
]

export function getLocale (i18n) {
  return i18n.global.locale.value
}

export function setLocale (i18n, locale) {
  i18n.global.locale.value = locale
}

export async function setupI18n () {
  const i18n = createI18n({
    locale        : import.meta.env.VITE_I18N_LOCALE,
    fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE,
    messages      : {},
    legacy        : false,
    missingWarn   : false,
    fallbackWarn  : false
  })
  i18n.languages = languages

  return i18n
}

export async function setI18nLanguage (i18n, locale) {
  // Loading messages
  await loadLocaleMessages(i18n, locale)

  setLocale(i18n, locale)
  document.querySelector('html')?.setAttribute('lang', locale)
}

export async function loadLocaleMessages (i18n, locale) {
  if (!i18n.global.availableLocales.includes(locale)) {
    const messages = (await import(`@/lang/locale/${locale}/index.js`)).default
    i18n.global.setLocaleMessage(locale, messages)
  }
}

const i18n = await setupI18n()

export default i18n
